module.exports = __webpack_public_path__ + "img/file-upload-icon.5a0870ca.png";